module.exports = __webpack_public_path__ + "img/badge.0fa134b5.svg";